module.exports = __webpack_public_path__ + "media/images/MICROBIUM-c5a2e63a08e2b26dddb964fab9397597.png";